module.exports = __webpack_public_path__ + "img/10.6078da87.png";